export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-27.96703d0c.jpg";